import React from "react";

const STYLES = {
  healthy: "bg-[#4D5B46]/30 text-[#A3C293] border-[#4D5B46]/50",
  down: "bg-[#5C2B29]/30 text-[#E5A09E] border-[#5C2B29]/50",
  unknown: "bg-elevated text-textmuted border-seam",
};

const DOT_STYLES = {
  healthy: "bg-[#A3C293] shadow-[0_0_8px_rgba(163,194,147,0.7)]",
  down: "bg-[#E5A09E] shadow-[0_0_8px_rgba(229,160,158,0.7)]",
  unknown: "bg-textmuted",
};

const LABELS = {
  healthy: "Healthy",
  down: "Down",
  unknown: "Unknown",
};

const StatusBadge = ({ status = "unknown", className = "" }) => {
  const key = STYLES[status] ? status : "unknown";
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs border ${STYLES[key]} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${DOT_STYLES[key]}`} />
      {LABELS[key]}
    </span>
  );
};

export default StatusBadge;
